module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAUklEQVQ4jWNgGAW4wH8t0pSH/P/9v4E05f+J1jB0lP9n/b/qfyAJpv+PAEr++h9EgmP+NwAV/IZoIdLtUC3BJHgVqoWkkAFpIV45VAspykcGAABTWXAj14Pc+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/auth/ic_done_white.png
// module id = 85
// module chunks = 453